import React, { useState, useEffect } from 'react';
import './App.scss';
import Main from './components/navbar/Main';
import Navbar from './components/navbar/Navbar';

interface iAppProps {
  pcRegion: string;
  clientAccessId: string;
  logo?: any;
  clientOrg: string;
  pcOauthClientId: string;
}

const App: React.FC<iAppProps> = ({ pcRegion,  clientAccessId, logo, clientOrg, pcOauthClientId }) => {

  const [userMe, setUserMe] = useState({});                         // Current Logged In User
  const [clientOrgLocal, setClientOrgLocal] = useState(clientOrg);  // Genesys Org. for the current logged in user

  /**
   * Reloads the app after a certain amount of time. The time is based on the OAuth Config in Genesys.
   * @param platformClient SDK main class
   */
  // const setReloadTime = (platformClient: any) => {
    
  //   let apiInstance = new platformClient.OAuthApi();

  //   let clientId = pcOauthClientId; // String | Client ID

  //   apiInstance.getOauthClient(clientId)
  //     .then((data: any) => {
  //       // console.log(`getOauthClient success! data: ${JSON.stringify(data, null, 2)}`);
  //       // console.log('getOauthClient success! data: ', data);
  //       setTimeout(() => {
  //         console.log('Authorization session expired. Reloading app.');
  //         window.location.reload();
  //       }, (data.accessTokenValiditySeconds ? data.accessTokenValiditySeconds : 24*60) * 1000);
        
  //     })
  //     .catch((err: any) => {
  //       console.log('There was a failure calling getOauthClient');
  //       console.error(err);
  //     });
  // }
  /**
   * Initialize the app component. Get current logged in user.
   */
  const initialize = () => {
    // console.log('App -> initialize');
    // setUserMe({});
    let platformClient = (window as any).platformClient;

    // setReloadTime(platformClient);

    let apiInstance = new platformClient.UsersApi();
    let opts = { 
        expand: ['division', 'organization'] // [String] | Which fields, if any, to expand.
    };
    apiInstance.getUsersMe(opts)
        .then((data: any) => {
          setUserMe(data);

          if (!clientOrg || clientOrg.trim().length <= 0)
            setClientOrgLocal(data.organization.thirdPartyOrgName);
        })
        .catch((err: any) => {
            console.log('There was a failure calling getUsersMe');
            console.error(err);
        });
  }

  /**
   * Runs onece uppon component mount.
   */
  useEffect(() => {
    initialize();
  // eslint-disable-next-line
  }, []);
  
  return (
    <div style={ {maxWidth: "470px"} }>
      <Navbar className="app-navbar" pcRegion={ pcRegion } caid={ clientAccessId } logo={ logo } memberMe={ userMe } clientOrg={ clientOrgLocal } />
      <div className="container" style={ {minWidth: "470px"} }>
        <Main clientOrg={ clientOrg } />
      </div>
    </div>
  );
}

export default App;
